import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { get } from "../../../utils/request";
import { getContext } from "../../../utils/context";
import "./deals-for-you.scss";

const destinationLabel = (deal) => {
  const destination = [deal.destinationCity, deal.destinationCountry].filter(Boolean).join(", ");
  return destination || (deal.applicabilityMode === "global" ? "" : "Travel deal");
};

export default function DealsForYou() {
  const [state, setState] = useState({ status: "loading", items: [] });
  const [expanded, setExpanded] = useState(false);

  const load = useCallback(async () => {
    setState({ status: "loading", items: [] });
    try {
      const items = await get("/bundleDeals/public", { currency: getContext().currency });
      const availableItems = Array.isArray(items) ? items : [];
      setState({ status: availableItems.length ? "ready" : "empty", items: availableItems });
    } catch (error) {
      setState({ status: error?.status === 404 ? "empty" : "error", items: [] });
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  if (state.status === "empty") return null;

  return (
    <section className="teleport-section deals-for-you" aria-labelledby="deals-for-you-title">
      <div className="deals-for-you__heading">
        <div>
          <h2 id="deals-for-you-title">Deals For You</h2>
        </div>
        <button type="button" className="teleport-secondary-button" onClick={() => setExpanded(true)}>
          View more <ArrowRight size={17} />
        </button>
      </div>

      {state.status === "loading" && <div className="teleport-state" role="status">Finding available deals…</div>}
      {state.status === "error" && (
        <div className="teleport-state teleport-state--error" role="alert">
          Deals are temporarily unavailable. <button type="button" onClick={load}>Try again</button>
        </div>
      )}
      {state.status === "ready" && (
        <div className="deals-for-you__grid">
          {(expanded ? state.items : state.items.slice(0, 3)).map((deal) => {
            const label = destinationLabel(deal);
            const hasFlights = Boolean(deal.services?.some(
              (service) => service.serviceType === "flights" && service.required !== false,
            ));
            const tripMeta = [
              hasFlights ? `${deal.durationNights} nights` : null,
              `${deal.travelers} ${deal.travelers === 1 ? "Traveller" : "Travellers"}`,
            ].filter(Boolean).join(" · ");

            return (
            <Link
              className="bundle-card"
              to={`/dealsforyou/${deal.shareSlug || deal._id}`}
              key={deal._id || deal.shareSlug}
              onClick={() => {
                if (typeof window.gtag === "function") {
                  window.gtag("event", "bundle_deal_click", {
                    bundle_deal_id: deal._id,
                    bundle_deal_title: deal.title,
                  });
                }
              }}
            >
              <img src={deal.heroImageUrl} alt="" loading="lazy" decoding="async" />
              <div className="bundle-card__scrim" />
              <div className="bundle-card__body">
                {label && <p>{label}</p>}
                <h3>{deal.title}</h3>
                <span>{tripMeta}</span>
                <strong>{deal.currency} {Number(deal.price || 0).toFixed(2)} <ArrowUpRight size={18} /></strong>
              </div>
            </Link>
          );})}
        </div>
      )}
    </section>
  );
}
